import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { router } from './routes';
import { queryClient } from './lib/query-client';
import { ErrorBoundary } from './components/ErrorBoundary';
import { applyConfig, getCachedConfig } from './lib/theme';
import { applyBrandDocumentMeta, paletteToOverrides, resolveBrand } from './brand';
import './index.css';

// Aplica a paleta do brand ativo (VITE_BRAND, build-time) ANTES de tudo -
// cobre inclusive o login (fora do ThemeProvider) sem depender de rede.
// Cache do backend (admin /admin/design-system, so pra brand 'just') aplica
// por cima em seguida, evitando flash de tema padrao no primeiro paint.
const brand = resolveBrand();
applyConfig({ overrides: paletteToOverrides(brand), logoUrl: null });
applyBrandDocumentMeta(brand);
applyConfig(getCachedConfig());

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elemento #root não encontrado em index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
